const gpxList = [
	"11_Listopada-asfalt-5.gpx",
	"1_Maja-asfalt-5.gpx",
	"1_MajaII-kostka-3.gpx",
	"1_MajaIII-asfalt-5.gpx",
	"3_MajaII-asfalt-5.gpx",
	"3_MajaIII-asfalt-5.gpx",
	"3_MajaIV-asfalt-5.gpx",
	"3_MajaV-asfalt-5.gpx",
	"3_MajaVI-asfalt-5.gpx",
	"3_MajaVIIIłącznik-asfalt-5.gpx",
	"3_MajaVIIłącznik-asfalt-5.gpx",
	"3_Maja_kładka-5.gpx",
	"Aleja_Zwycięstwa-asfalt-5.gpx",
	"Andresa-asfalt-5.gpx",
	"Armii-KrajowejIII-asfalt-5.gpx",
	"Armii_KrajowejI-asfalt-5.gpx",
	"Armii_KrajowejII-asfalt-5.gpx",
	"BCPI-asfalt-5 (1).gpx",
	"BCPI-asfalt-5.gpx",
	"BlachnickiegoI-asfalt-5.gpx",
	"Będzińska-kostka-3.gpx",
	"Długosza-asfalt-5.gpx",
	"Gospodarcza-asfalt-4.gpx",
	"Górka_Środulska-kostka-2.gpx",
	"Innowacyjna-kostka-2.gpx",
	"Jagiellońska-asfalt-5.gpx",
	"Janowskiego-kostka-1.gpx",
	"JanowskiegoII-kostka-2.gpx",
	"JanowskiegoIII-kostka-2.gpx",
	"Klimontowska-kostka-3.gpx",
	"Kombajnistów-kostka-3.gpx",
	"Komuny_Paryskiej-kostka-3.gpx",
	"Kosów-kostka-3.gpx",
	"KościelnaI-asfalt-5.gpx",
	"KościelnaII-asfalt-5.gpx",
	"Kresowa-asfalt-5.gpx",
	"KresowaII-asfalt-4.gpx",
	"Kładka_Sos_Poł-4.gpx",
	"Lwowska-asfalt_kostka-3.gpx",
	"Małachowskiego-asfalt-4.gpx",
	"Mieroszewskich_0.gpx",
	"MieroszewskichI-asfalt-5.gpx",
	"MieroszewskichII-kostka3.gpx",
	"Mierosławskiego-asfalt-4.gpx",
	"MireckiegoI-asfalt-5.gpx",
	"MireckiegoII-kostka-3.gpx",
	"Modrzejowska-płyty-5.gpx",
	"Mościckiego-asfalt-5.gpx",
	"NarutowiczaI-kostka-3.gpx",
	"NarutowiczaII-kostka-3.gpx",
	"NarutowiczaIII-asfalt-5.gpx",
	"Norwida-kostka-3.gpx",
	"Orla-asfalt-5.gpx",
	"Orląt_LwowskicgII-kostka-3.gpx",
	"Orląt_LwowskichI-kostka-2.gpx",
	"Orląt_LwowskichI-kostka-3.gpx",
	"Orląt_LwowskichII-kostka-2.gpx",
	"Ostrogórska-asfalt-5.gpx",
	"Park_Harcerski_łącznik-asfalt-5.gpx",
	"Parkowa-wiadukt-3.gpx",
	"Partyzantów-kostka-3.gpx",
	"PiłsudskiegoII-asfalt-5.gpx",
	"PiłsudskiegoIII-asfalt-5.gpx",
	"PiłsudskiegoI_3_MajaI-asfalt-5.gpx",
	"Roweckiego-asfalt-5.gpx",
	"RoweckiegoII-asfalt-4.gpx",
	"RoweckiegoIII-asfalt-4.gpx",
	"RoweckiegoIV-kostka-3.gpx",
	"RoweckiegoV-asfalt-4.gpx",
	"RoweckiegoVI-asfalt-4.gpx",
	"S86-kostka_piach-2.gpx",
	"SienkiewiczaI-asfalt-5.gpx",
	"SienkiewiczaII-asfalt-5.gpx",
	"Sobieskiego-kostka-3.gpx",
	"SobieskiegoII-asfalt-5.gpx",
	"Stawiki-asfalt-5.gpx",
	"Szlak_Czarnego_Morza-mieszane-2.gpx",
	"Szlak_Dawnego_Pogranicza-mieszane-2.gpx",
	"Szlak_Lasu_Zagórskiego-gruntowa-1.gpx",
	"Teatralna-asfalt-5.gpx",
	"Towarowa-asfalt-4.gpx",
	"Warszawska-kostka-3.gpx",
	"Watta-kostka-3.gpx",
	"Wawel-asfalt-5.gpx",
	"Wiosenna-asfalt-4.gpx",
	"Wojska_PolskiegoI-asfalt-5.gpx",
	"Wojska_PolskiegoII-asfalt-4.gpx",
	"Wojska_PolskiegoIII-asfalt-4.gpx",
	"Wojska_PolskiegoIV-kostka-3.gpx",
	"Wojska_PolskiegoIX-kostka-2.gpx",
	"Wojska_PolskiegoV-kostka-3.gpx",
	"Wojska_PolskiegoVI-kostka-2.gpx",
	"Wojska_PolskiegoVII-kostka-2.gpx",
	"Wojska_PolskiegoVIII-kostka-2.gpx",
	"Wojska_PolskiegoX-kostka-2.gpx",
	"Wyszyńskiego-kostka-4.gpx",
	"ZegadłowiczaI-asfalt-5.gpx",
	"ZegadłowiczaII-asfalt-5.gpx",
	"Śmigielskiego-asfalt-4.gpx",
	"Żeromskiego-asfalt-5.gpx",
	"Żytnia-asfalt-4.gpx",
];
// import { gpxList } from './GPX';
export { gpxList };